export function extractNumberFromText(text) {
  console.log(text);
  if (!text) return undefined;
  const match = text.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
}
